<template>
    <div class="kt-portlet__head">
         <form class="isprint-filter" autocomplete="off"> 
            <div class="form-group  ">
                <label>Descrizione</label><br>
                <input class="form-control form-control-sm"  autocomplete="off" name="adasd" placeholder="Descrizione" type="text" style="width:150px" v-model="search.DESCRIZIONE.VALUE">
            </div>
            <button class="btn btn-success float-right btn-sm my-2 my-sm-3" v-on:click="creaTipologiaAnagrafica()"><i class="fas fa-file-plus"></i> Crea Tipologia</button>
        </form> 
    </div>
    <div class="isprint-grid-container"  >    
        <table class="isprint-grid shadow" >
            <thead class="isprint-grid-thead" >
                <tr style="left: 0px;background: #ADADAD;color:#fff">
                    <th  style="width:90%"><span >Descrizione</span></th>
                    <th  style="width:10%"><span >Azioni</span></th>
                </tr>
            </thead>
            <tbody class="isprint-grid-tbody" style="font-size:14px !important">
                <tr style="left: 0px;height:50px" v-bind:key="tipologia.ID_TIPOLOGIA"  v-for="tipologia in paginatedList.arr">                        
                    <td  style="width:90%;font-size:16px;font-weight:bold">
                        <div class="float-left ml-2" style="min-width:60px">
                            <i class=" fa-3x" style="color:#62106e" v-bind:class="tipologia.ICONA"></i>
                        </div>
                        <div class="float-left ml-3 mt-3">
                            {{tipologia.DESCRIZIONE}}
                        </div>                                                
                    </td>
                    <td  style="width:10%">
                        <div class="btn-group float-right" role="group" aria-label="Basic example">
                            <button data-toggle="tooltip" data-placement="top" title="Modifica il cliente" class="btn btn-warning btn-sm float-right" v-on:click="modificaTipologiaAnagrafica(tipologia.ID_TIPOLOGIA)"><i class="fal fa-pencil"></i></button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
         <Pagine v-model="search.PAGINATION.PAGE_NUMBER"  :numrighe="paginatedList.count"  :numpagine="search.PAGINATION.LENGTH"></Pagine> 
    </div>
    <div class="modal fade" id="popUpTipologiaAnagrafica" data-backdrop="true" role="dialog"  aria-modal="true" >
        <div class="modal-dialog" style="min-width:500px;"  >
            <div class="modal-content" >
                <div class="modal-header modal-header" style="background-color: #ADADAD;">
                    <h4 style="color:#fff" class="modal-title"><i class="fas fa-pencil"></i></h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" >    
                    <div class="form-group row">
                        <!-- <div class="row" style="width:100%"> -->
                        <div class="form-group col-md-12" style="margin-bottom:.50rem">
                            <label >Descrizione</label>
                            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="Descrizione Tipologia" v-model="tipologiaSelezionata.DESCRIZIONE">  
                        </div>
                        <div class="form-group col-md-10" style="margin-bottom:.50rem">
                            <label >Icona</label>
                            <input autocomplete="off" type="text" class="form-control form-control-sm" placeholder="Descrizione Tipologia" v-model="tipologiaSelezionata.ICONA">  
                        </div> 
                        <div class="form-group col-md-2 pr-4 mt-2" style="margin-bottom:.50rem">
                            <i class="fa-3x float-right" v-bind:class="tipologiaSelezionata.ICONA"></i>
                        </div> 
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-success float-right" v-on:click="salvaTipologiaAnagrafica()"><i class="fa fa-check"></i> Salva</button>
                </div>
            </div>  
        </div>
    </div>
</template>
<script>

import Pagine from '@/components/utils/Pagine.vue'

//import PersonaGiuridica from '../components/common/PersonaGiuridica.vue'
import DatePicker from '../components/utils/DatePicker.vue'
//import ISwitch from '../components/utils/ISwitch.vue'



export default {
    name:"TipologiaPratica",
    components:{
        Pagine,
        //PersonaGiuridica,
        //ISwitch
    },
    data:function(){
        return{
            filters:global.filters,
            search:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:50},
                DESCRIZIONE:{TYPE:'TEXT',VALUE:''},   
            },
            tipologiaSelezionata: {},
            arrayTipologiaAnagrafiche:new Array(),
        }
    },
    methods: {
        getTipologieAnagrafica : function(){
            global.utils.get('/emmet/anagrafiche_tipologie',{}, (response) => {       
                this.arrayTipologiaAnagrafiche = response.data           
            });
        },

        getTipologiaAnagrafica: function(idTipologia){            
            global.utils.get('emmet/anagrafica_tipologia',{ID_TIPOLOGIA: idTipologia},(response)=>{
                this.tipologiaSelezionata = utils.clone(response.data); 
            }) 
        },      
        creaTipologiaAnagrafica : function(){
            this.tipologiaSelezionata = {ID_TIPOLOGIA:0,ICONA:'fas fa-file-invoice'}
            var modal = utils.openModal('popUpTipologiaAnagrafica'); 
        },
        modificaTipologiaAnagrafica : function(idTipologia){
            //api persona fisica
            var modal = utils.openModal('popUpTipologiaAnagrafica');
            this.getTipologiaAnagrafica(idTipologia)
        
        },
        deleteTipologiaAnagrafica : function(idTipologia){
            utils.alert.confirm("Sei sicuro di voler eliminare questa tipologia?",()=>{
            global.utils.delete('emmet/anagrafica_tipologia',{ID_TIPOLOGIA: idTipologia},(response) => {
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                    this.getTipologiaAnagrafica();
                }

            });
        },this.$root);  
        },
        salvaTipologiaAnagrafica : function(){
            //update
            if(this.tipologiaSelezionata.ID_TIPOLOGIA> 0){
                global.utils.put('emmet/anagrafica_tipologia',this.tipologiaSelezionata, (response) => {
                    if (response.esito == 0){
                        this.getTipologieAnagrafica();
                        var modal = utils.closeModal('popUpTipologiaAnagrafica')
                        utils.alert.success(response.messaggio);
                    }
                });
            }else{
            //insert
                global.utils.post('emmet/anagrafica_tipologia',this.tipologiaSelezionata,(response)=>{
                    if (response.esito == 0){
                        this.getTipologieAnagrafica()
                        var modal = utils.closeModal('popUpTipologiaAnagrafica')
                        utils.alert.success(response.messaggio);
                    }
                });
            }
        },
    },
    computed : {
        paginatedList(){
            var arr = utils.inGrid(this.arrayTipologiaAnagrafiche,this.search);
            return arr;
        }, 
    },
    created : function(){
        this.getTipologieAnagrafica()
    
    },

}


    </script>
